<template lang="pug">
  .b-spec-history-panel(data-testid="history-panel")
    ._head
      ._title История спецификации
      button._close(type="button" data-testid="history-close" @click="$emit('close')") ×
    select._filter(data-testid="history-filter-kind" v-model="kind" @change="load")
      option(value="" data-testid="history-filter-kind-option") все записи
      option(v-for="(title, code) in HISTORY_KINDS" :key="code" :value="code" data-testid="history-filter-kind-option") {{ title }}
    ._empty(v-if="!records.length") Записей пока нет
    ._record(v-for="record in records" :key="record.id" data-testid="history-record")
      span._time(data-testid="history-record-time") {{ dateTime(record.createdAt) }}
      span._author(data-testid="history-record-author") {{ authorText(record) }}
      template(v-if="record.kind === 'file'")
        span._field(data-testid="history-record-field") Файл импорта
        a._file(
          v-if="record.file && record.file.url"
          :href="record.file.url"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="history-record-file"
          ) {{ record.newValue || record.file.name }}
        span._new(v-else data-testid="history-record-file") {{ record.newValue }} (файл удалён)
        button._reimport(
          v-if="record.file && !readOnly"
          type="button"
          data-testid="history-record-reimport"
          @click="$emit('reimport', record)"
          ) Импортировать снова
      template(v-else)
        span._item(data-testid="history-record-item") {{ record.itemName || '—' }}
        span._field(data-testid="history-record-field") {{ record.field ? fieldTitle(record.field) : HISTORY_KINDS[record.kind] }}
        span._old(data-testid="history-record-old") {{ record.oldValue || '—' }}
        span._new(data-testid="history-record-new") {{ record.newValue || '—' }}
        span._reason(v-if="record.reason" data-testid="history-record-reason") {{ record.reason }}
</template>

<script>
import specificationApi from '@/api/specification';
import { HISTORY_KINDS, dateTime, fieldTitle } from '@/utils/spec';

/**
 * Боковая панель «История спецификации» (ТЗ 6.2): время, кто, позиция, поле, старое → новое,
 * причина; фильтр по виду записи. Записи удалённых позиций остаются читаемыми — сервер хранит
 * снимок названия. Файлы, загруженные для импорта, — отдельные записи (вид «Файлы»): ссылка на
 * скачивание и «Импортировать снова». Сгенерировано Claude.
 */
export default {
  name: 'SpecHistoryPanel',
  props: {
    specificationId: { type: Number, required: true },
    /** Архивный проект: импортировать снова нельзя, скачать файл можно (ТЗ 6.9). */
    readOnly: Boolean,
  },
  data() {
    return {
      HISTORY_KINDS,
      kind: '',
      records: [],
    };
  },
  created() {
    this.load();
  },
  methods: {
    dateTime,
    fieldTitle,
    load() {
      const params = this.kind ? { kind: this.kind } : {};
      specificationApi.fetchHistory(this.specificationId, params)
        .then((r) => { this.records = r.items ?? []; });
    },
    authorText(record) {
      const map = {
        designer: 'дизайнер',
        supplier: 'поставщик',
        customer: 'заказчик',
        system: 'система',
        ai: 'AI',
      };
      return map[record.authorType] ?? record.authorType ?? '';
    },
  },
};
</script>

<style scoped lang="scss">
.spec-history-panel {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 560px;
  max-width: 100%;
  z-index: 9000;
  background: var(--color-white);
  box-shadow: -6px 0 24px rgba(0, 0, 0, 0.14);
  padding: 20px;
  overflow-y: auto;
  box-sizing: border-box;

  &__head {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }

  &__title {
    font-size: 20px;
    font-weight: 700;
    flex-grow: 1;
  }

  &__close {
    border: none;
    background: none;
    font-size: 24px;
    line-height: 1;
    cursor: pointer;
  }

  &__filter {
    box-sizing: border-box;
    padding: 6px 8px;
    border: 1px solid var(--color-super-light);
    border-radius: 6px;
    font: inherit;
    font-size: 12px;
    margin-bottom: 12px;
  }

  &__record {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 10px;
    padding: 8px 0;
    border-bottom: 1px solid var(--color-super-light);
    font-size: 12px;
  }

  &__time,
  &__author {
    color: var(--color-middle-gray);
    white-space: nowrap;
  }

  &__item {
    font-weight: 700;
  }

  &__file {
    font-weight: 700;
    color: var(--color-accent);
    word-break: break-all;
  }

  &__reimport {
    border: none;
    background: none;
    font: inherit;
    color: var(--color-accent);
    cursor: pointer;
    padding: 0;
    margin-left: auto;
  }

  &__reason {
    flex-basis: 100%;
    color: var(--color-middle-gray);
  }

  &__empty {
    color: var(--color-middle-gray);
  }
}
</style>
